/**
 * created by Alex Xia on 1/8/19
 * Description:
 */
import { Subject } from 'rxjs';
import { Entity } from '../../tamalelibs/models/entity.model';

export class EntityDetailConfig {
    // data
    embedMode: boolean;
    isSideSheet: boolean;
    entity: Entity;
    customMetadata: any[] = [];

    constructor() {
        this.actionSubject$ = new Subject<EntityAction>();
        this.feedbackSubject$ = new Subject<EntityFeedbackAction>();
    }

    public actionSubject$: Subject<EntityAction>;
    public feedbackSubject$: Subject<EntityFeedbackAction>;
}

export class EntityAction {
    constructor(public type: EntityActionTypes, public payload: any) { }
}

export class EntityFeedbackAction {
    constructor(public type: EntityFeedbackTypes, public payload: any) { }
}

export enum EntityActionTypes {
    SWITCH_ANOTHER_ENTITY = 'SWITCH_ANOTHER_ENTITY',
    SIDE_SHEET = 'SIDE_SHEET'
}

export enum EntityFeedbackTypes {
    ENTITY_LOADED = 'ENTITY_LOADED',
    ENTITY_UPDATED = 'ENTITY_UPDATED'
}
